import { obterEmpresasAsync } from "../../services/empresaService";

const atualizarEmpresas = async ({ commit }) => {
    const empresas = await obterEmpresasAsync();
    commit('atualizarEmpresas', empresas);
}

const atualizarEmpresa = ({ commit }, empresa) => {
    commit('atualizarEmpresa', empresa);
}

export default {
    atualizarEmpresas,
    atualizarEmpresa
}